// eslint-disable-next-line import/prefer-default-export
export const transform = (transaction) => ({
  ...transaction,
  datetime: new Date(transaction.datetime),
  updatedAt: new Date(transaction.updatedAt),
  createdAt: new Date(transaction.createdAt),
});
